import { CpOrderInvoicesSearchModel } from './cp_order_invoices_search_types';
import utilSvc from '../../../../core/utilSvc';

/**
 * Formats the CP Order Invoices search form state into the legacy API request shape.
 * @param state The search form state
 * @returns The formatted request object
 */
export function formatCpOrderInvoicesRequest(state: CpOrderInvoicesSearchModel): object {
    const CEID = state.CE.val === 'N/A' ? [] : state.CE.val;
    return {
        Context: {
            CEID: CEID ? (Array.isArray(CEID) ? CEID : [CEID]) : [],
            RXID: state.RX.val ? state.RX.val : [],
        },
        Params: {
            StartDate: state.StartDate.val ? toIsoDateCompat(state.StartDate.val) : '',
            EndDate: state.EndDate.val ? toIsoDateCompat(state.EndDate.val) : '',
            Tpa:
                state.ProgramAdmin && state.ProgramAdmin.val && state.ProgramAdmin.val !== 'N/A'
                    ? state.ProgramAdmin.val
                    : '',
            OverallocatedOnly: !!state.OverallocatedOnly.val,
            RebatesOnly: !!state.RebatesOnly.val,
        },
        Paging: {
            Size: 20000,
            TooMany: false,
        },
        SortBy: [
            {
                Field: 'VendorInvoiceDate',
                Order: 'DSC',
            },
        ],
    };
}

// Accepts yyyy-MM-dd string or Date, returns yyyy-MM-ddT08:00:00.000Z using utilSvc.dt.toIsoDate
function toIsoDateCompat(date: string | Date): string {
    if (!date) return '';
    if (typeof date === 'string') {
        return utilSvc.dt.toIsoDate(date);
    }
    // Date object: format as yyyy-MM-dd, then use utilSvc
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return utilSvc.dt.toIsoDate(`${y}-${m}-${d}`);
}
